// ----------------------------------------------------------------------

export default function Breadcrumbs({ theme }) {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          marginLeft: 4,
          marginRight: 4
        }
      }
    }
  };
}
